<div
  class="flex min-w-[260px] items-center gap-1 text-sm"
  [ngClass]="{
    'text-info-600': prescriptionType() === type.Drugs,
    'text-warning-600': prescriptionType() === type.InstrumentalDiagnostic,
    'text-success-600': prescriptionType() === type.LaboratoryService,
    'text-purple-600': prescriptionType() === type.Appointment || prescriptionType() === type.PersonalDoctorAppointment,
  }"
  [matTooltip]="'prescription.descriptions.type' | translate"
>
  <mat-icon [svgIcon]="getIconName(prescriptionType())"></mat-icon>
  {{ "medicalServices.prescriptionTypes." + prescriptionType() | translate }}
</div>
